import { SelectMui } from 'src/components/SelectMui'
import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const CustomSelect = styled(SelectMui)`
    width: 16rem;    
    margin: 0 !important;
    height: 2.5rem !important;
`
export const CustomButton = styled(ButtonMui)`
    width: 12rem;    
    height: 2.5rem !important;
    margin: 0 !important;
`
